module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMDAgMjAwIj48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6IzAwYjNlNjt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPkhTX2ljb25fPC90aXRsZT48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik05Ny44NywxMjMuNDhMNDkuNTcsNTIuNDNIMTUwLjQzWk03OS4yNyw2OC4xNUw5OC40MSw5Ni4zMmwyMC44My0yOC4xN2gtNDBaIi8+PHJlY3QgY2xhc3M9ImNscy0xIiB4PSI2NS4wNyIgeT0iMTMxLjg1IiB3aWR0aD0iNzAuNDEiIGhlaWdodD0iMTUuNzIiLz48L3N2Zz4="


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/images/HS_icon_Blue.svg
 ** module id = 1095
 ** module chunks = 0
 **/